module.exports = __webpack_public_path__ + "img/content.df8b4058.png";